export const MenuItems = [
  { match: (path) => path === "/", title: null },
  { match: (path) => path.startsWith("/patient/"), title: "Patients" },
  { match: (path) => path === "/patients", title: "Patients" },
  { match: (path) => path === "/reports", title: "Reports & Insights" },
  { match: (path) => path === "/billing-report", title: "Billing Report" },
  {
    match: (path) => path === "/import-export-wizard",
    title: "Import/Export Wizard",
  },
  { match: (path) => path === "/import-patients", title: "Import Patients" },
  { match: (path) => path === "/export-patients", title: "Export Patients" },
  {
    match: (path) => path.startsWith("/import-export-history"),
    title: "Import/Export History",
  },
  { match: (path) => path === "/assign-patients", title: "Assign Patients" },
  { match: (path) => path === "/seeding-entry", title: "Seeding Entry" },
  { match: (path) => path === "/settings", title: "Settings" },
  { match: (path) => path === "/practice-terms", title: "T&C" },
  { match: (path) => path === "/help", title: null },
  { match: (path) => path === "/profile", title: "Profile" },
  {
    match: (path) => path === "/organization-portal",
    title: "Organization Portal",
  },
];

export const getPageTitle = (pathname) => {
  const found = MenuItems.find((item) => item.match(pathname));
  return found?.title ?? "";
};
